module.exports = __webpack_public_path__ + "img/3xlogo.efd6aae1.svg";